import { store } from 'app_storage/redux-storage';
import { Http, HttpCustomStructure } from 'app_utils/http';
import { ScreenNotificationsUtil } from 'app_utils/screenNotification';
// @import_dependencies
// @end

// @import services
// @end

// @import utilities
// @end

// @import types
// @end

export type FactoryReportType = 'modality' | 'overview_programs' | 'general_student_certificates' | 'provision_of_professionals' | 'users_characterization' | 'transactions';

export interface ReportFactoryParams{
  user: string;
  report: FactoryReportType,
  title?: string;
  output_format?: 'xlsx' | 'json';
  auditor?: boolean;
  reportStartDate?: string | undefined,
  reportEndDate?: string | undefined
  modality?: string;
  serviceIds?: string[]
}

class ReportService {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  private storeObject = store;
  private token: string;
  private screenNotification = new ScreenNotificationsUtil();
  private Http = Http;

  constructor () {}

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  generateReport = async (params: Partial<ReportFactoryParams>) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/reports/factory/generate-report`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

}

export default ReportService
